export default __webpack_public_path__ + "static/media/image-7.89211736.png";